// extracted by mini-css-extract-plugin
export var content = "SideMenu-module--content--0a151";
export var fadeInAnimation = "SideMenu-module--fadeInAnimation--5e173";
export var wrapper = "SideMenu-module--wrapper--e6545";